import { Component, Inject, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { validateAllFormFields } from '../utils/calsoft-validators';
import { NotesService } from 'src/app/services/notes.service';
import { Constant } from 'src/app/constants/constant';

@Component({
  selector: 'app-notes',
  templateUrl: './notes.component.html',
  styleUrls: ['./notes.component.scss']
})
export class NotesComponent implements OnInit {

  firstFormGroup: UntypedFormGroup;

  id: any;
  text: string;
  data: any;
  @Input() type: any;
  activityId: number;


  activityType: any;
  productId: any;
  note: any;
  noteId: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) data,
    private _formBuilder: UntypedFormBuilder,
    private snackBar: MatSnackBar,
    private dialogRef: MatDialogRef<NotesComponent>,
    private crmNoteService: NotesService,
    private dialog: MatDialog,
  ) {

    this.data = data;
    this.productId = data['productId'];
    this.noteId=data['noteId'];
    this.note=data['note']
  }

  leadId: any;

  ngOnInit() {


    this.initNote();

    this.firstFormGroup.get("leadId").setValue(this.data['productId']);

    this.text = "Save";

    if(this.noteId>0){

      this.editlead(this.note);
    }

  }

  initNote() {
    this.firstFormGroup = this._formBuilder.group({
      noteId: [0],
      notes: [''],
      notesDocument: [''],
      leadId: [''],
      createdDate: [''],
      updatedDate: [''],
      createdBy: [''],
      updatedBy: [''],
      type: [''],
    });
  }

  submitType() {

    this.dialogRef.close({ event: 'add', })

  }


  getAllNotesId(productId) {
    this.crmNoteService.getNoteById(productId)
      .subscribe(
        (productId: any) =>
          this.editlead(productId),
        (err: any) => { }
      );
  }

  editlead(productId: any) {

    this.firstFormGroup = this._formBuilder.group({
      noteId: productId.noteId,
      notes: productId.notes,
      notesDocument: productId.notesDocument,
      leadId: productId.leadId,
      createdDate: productId.createdDate,
      updatedDate: productId.updatedDate,
      createdBy: productId.createdBy,
      updatedBy: productId.updatedBy,
      type: productId.type,
    })


  }


  close() {
    this.dialog.closeAll();
  }

  submit() {
    if (this.text == 'Save' && this.firstFormGroup.valid) {

      if (this.firstFormGroup.value.noteId != 0) {
        this.firstFormGroup.value.operationType = "Change"
      }
      else {
        this.firstFormGroup.value.operationType = "New"
      }

      this.firstFormGroup.value.leadId = this.productId

      this.text = "Processing"
      this.crmNoteService.addOrEditNote(this.firstFormGroup.value).subscribe(
        (response) => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.text = "Save";
            this.snackBar.open('Notes Added Successfully !', 'X', { duration: 3000, verticalPosition: 'bottom', panelClass: ['success'],});
            this.submitType();
          }
          else {
            this.text = "Save";
            this.snackBar.open('Notes Added Failed !', 'X', { duration: 3000, verticalPosition: 'bottom', panelClass: ['error'],});
          }
        },
        () => { this.text = "Save" });
    }
    else {
      validateAllFormFields(this.firstFormGroup);
    }
  }

}